import { useRouterState } from "@tanstack/react-router";

import { cn } from "@/lib/utils";
import { TopNav } from "./nav-header";
import { WorkspaceTabBar, useWorkspaceEnabled, WorkspaceContent } from "@/features/workspaces";

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const isWorkspacesEnabled = useWorkspaceEnabled();
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const isTakeoffPilotJobRoute = /^\/takeoffPilot\/(?!new$)[^/]+$/.test(pathname);
  const isFullBleedRoute =
    pathname.startsWith("/revCollab/revisions/") ||
    isTakeoffPilotJobRoute;

  return (
    <div
      data-slot="app-shell"
      className="flex h-screen w-full flex-col overflow-hidden bg-background"
    >
      {!isTakeoffPilotJobRoute && <TopNav />}

      {/* Workspace TabBar */}
      {isWorkspacesEnabled && <WorkspaceTabBar />}

      {/* Page Content */}
      <main
        data-slot="page-main"
        className={cn(
          "flex-1",
          isWorkspacesEnabled || isFullBleedRoute ? "overflow-hidden" : "overflow-y-auto"
        )}
      >
        {isWorkspacesEnabled ? (
          <WorkspaceContent />
        ) : isFullBleedRoute ? (
          children
        ) : (
          <div data-slot="page-content" className="p-6 lg:p-8">
            {children}
          </div>
        )}
      </main>
    </div>
  );
}

/*
 * Usage Example:
 *
 * // In __root.tsx
 * import { AppShell } from "@/components/layout";
 *
 * export const Route = createRootRoute({
 *   component: () => (
 *     <AppShell>
 *       <Outlet />
 *     </AppShell>
 *   ),
 * });
 */
